(function () {
	const initSlider = () => {
		let productSlider;
		const productSliders = document.querySelectorAll('.image-contents__swiper');

		productSliders.forEach((slider, index) => {
			productSlider = new Swiper(slider, {
				slidesPerView: 1.5,
                spaceBetween: 16,
				navigation: {
                    nextEl: ".image-contents__button-next",
                    prevEl: ".image-contents__button-prev",
                },
				breakpoints: {
					1200: {
						slidesPerView: 4
					},
					769: {
						slidesPerView: 3
					}
				}
			});
		});
	};

	const destroySlider = () => {
		const productSliders = document.querySelectorAll('.image-contents__swiper');

		productSliders.forEach((slider, index) => {
			if (slider.swiper !== undefined) slider.swiper.destroy();
		});
	};

	const initSection = () => {
		const sections = document.querySelectorAll('.image-contents-section');

		const sectionResizeObserver = new ResizeObserver((entries) => {
			destroySlider();
			initSlider();
		});

		destroySlider();
		initSlider();

		sections.forEach(item => {
			sectionResizeObserver.observe(item);
		});
	};

	initSection();

	document.addEventListener('shopify:section:load', function () {
		initSection();
	});
})();
